import { useContext, useEffect, useRef } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { AuthContext } from "../contexts/AuthContext";
import { apiClient } from "../service/ApiService";

export const useAxiosInterceptor = () => {
  const { logout } = useContext(AuthContext);
  const interceptorId = useRef<number | null>(null);

  useEffect(() => {
    interceptorId.current = apiClient.interceptors.response.use(
      (response) => response,
      async (error) => {
        const statusCode = error.response?.status;
        if (statusCode === 401 || statusCode === 403) {
          // Only force logout when we genuinely lack credentials. A 401/403
          // while we still hold a token + userId is a resource/permission
          // error, not a dead session — don't kick the user out for it.
          const token = await AsyncStorage.getItem("userToken");
          const userId = await AsyncStorage.getItem("userId");
          if (!token || !userId) {
            logout();
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      if (interceptorId.current !== null) {
        apiClient.interceptors.response.eject(interceptorId.current);
      }
    };
  }, [logout]);
};

export default useAxiosInterceptor;
